import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { clearSession, useAuthSession } from '@/lib/session'

export default function Unauthorized() {
  const session = useAuthSession()

  useEffect(() => {
    clearSession()
  }, [])

  return (
    <main className="min-h-screen bg-slate-50 px-6 py-10 text-slate-900">
      <section className="mx-auto flex min-h-[calc(100vh-5rem)] max-w-md items-center justify-center">
        <div className="w-full rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-500">Unauthorized</p>
          <h1 className="mt-3 text-2xl font-semibold tracking-tight text-slate-950">Access denied</h1>
          <p className="mt-2 text-sm leading-6 text-slate-600">Please sign in again to continue.</p>
          <Link
            to={session ? '/' : '/login'}
            className="mt-6 inline-flex items-center justify-center rounded-full bg-brand-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-700"
          >
            {session ? 'Go home' : 'Sign in'}
          </Link>
        </div>
      </section>
    </main>
  )
}
